module.exports = __webpack_public_path__ + "e596fe4.woff2";